import { css } from "../../../../../styled-system/css";

export const styles = {
  root: () =>
    css({
      display: "flex",
      flexDirection: "row",
      rowGap: "baseUnit.mobile2",
      columnGap: "baseUnit.mobile1",
      flexWrap: "wrap",
      maxWidth: "528px",
      margin: "auto",
      tablet: {
        maxWidth: "none",
        margin: 0,
      },
    }),
  item: () =>
    css({
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "4px",
      color: "headlineGrey",
      "& svg": {
        fill: "headlineGrey",
      },
      "& svg path": {
        fill: "headlineGrey",
      },
      "& p": {
        fontSize: "body.cat",
        letterSpacing: "body.cat",
        lineHeight: "body.cat",
        marginBottom: 0,
        color: "headlineGrey",
      },
    }),
  icon: () =>
    css({
      "& svg": {
        height: "baseUnit.mobile2",
        width: "baseUnit.mobile2",
      },
    }),
};
